import CustomDropdown from "../../../../components/CustomDropdown";
import { AddUserSchema, EditUserSchema } from "../../../../components/Helpers";
import Hoc from "../../../../components/HOC";
import { Formik, Form, Field } from "formik";
import React, { useState, useEffect, useRef } from "react";
import {
  requestUserAction,
  setResetStateUser,
} from "../../../../Redux/UserState/UserActionCreator";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import TextInput from "../../../../components/TextInput";
import PhoneInput from "../../../../components/PhoneInput";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { MdArrowBack } from "react-icons/md";
import CustomDatePicker from "../../../../components/CustomDatePicker";
// import PhoneInput from "react-phone-number-input";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FiUsers, FiUser } from "react-icons/fi";
import MuiDatePicker from "../../../../components/MuiDatePicker";
import { date } from "yup";
import zipcodes from 'zipcodes';

const AddEmployeeForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const title = "Add Employee";
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [phoneCode, setPhoneCode] = useState("+1");
  const addUserReducer = useSelector((state) => state.UserReducer);
  const initialValues = {
    userName: "",
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    gender: "",
    joinDate: null,
    endDate: null,
    dateOfBirth: null,
    // role: "",
    phone: null,
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "USA",
    zip: "",
    acctType: "USER",
    stsCd: "A",
  };
  const countryOptions = [
    { value: "USA", label: "USA" },
    { value: "IN", label: "IN" },
  ];
 
  const countryCodeOptions = [
    { value: "USA", label: "+1" },
    { value: "IN", label: "+91" },
  ];

  const [isAddressAutoFilled, setIsAddressAutoFilled] = useState(false);

  const handleAddEmployee = (newEmployee, { resetForm }) => {
    setIsSubmitting(true);
    // dispatch(requestUserAction({...newEmployee,role:newEmployee.acctType}));
    dispatch(requestUserAction(newEmployee));
    // resetForm();
  };

  useEffect(() => {
    if (!addUserReducer?.isLoading && addUserReducer?.isResponse) {
      toast.success("User Created successfully");
      setIsSubmitting(false);
      navigate("/manageemployee");
      dispatch(setResetStateUser());
    }
    if (!addUserReducer?.isLoading && addUserReducer?.isError) {
      toast.error("User not created. Something went wrong");
      dispatch(setResetStateUser());
      setIsSubmitting(false);
    }
  }, [addUserReducer]);

  const updateCountryDropdown = (selectedCode) => {
    const country = countryCodeOptions.find(
      (option) => option.label === selectedCode
    );
    if (country) {
      const countryValue = country.value;
      // Update country field value based on phone code
      setPhoneCode(selectedCode);
      return countryValue;
    }
    return "USA";
  };

  const handleCountryChange = (selectedOption, setFieldValue) => {
    setFieldValue("country", selectedOption.value);
    // Clear all address fields when country changes
    setFieldValue('city', '');
    setFieldValue('state', '');
    setFieldValue('zip', '');
    setFieldValue('addressLine1', '');
    setFieldValue('addressLine2', '');
    setIsAddressAutoFilled(false);
  };

  const handleZipCodeChange = (e, setFieldValue, values) => {
    const zipCode = e.target.value;
    
    // Check if country is USA
    if (values.country === 'USA') {
      // Check if zipcode is 5 digits long (standard US format)
      if (zipCode.length === 5) {
        const location = zipcodes.lookup(zipCode);
        // If valid US zipcode, auto-fill city and state
        if (location) {
          setFieldValue('city', location.city);
          setFieldValue('state', location.state);
          setFieldValue('country', 'USA');
          setIsAddressAutoFilled(true);
          setFieldValue('zip', zipCode);
        } else {
          // Show error if zipcode lookup fails
          toast.error('Invalid ZIP code');
          setIsAddressAutoFilled(false);
        }
      } else {
        // Reset auto-fill if zipcode length is not 5
        setIsAddressAutoFilled(false);
      }
    } 
    // Check if country is India
    else if (values.country === 'IN') {
      // Validate Indian PIN code length (6 digits)
      if (zipCode.length > 6) {
        toast.error('ZIP code cannot exceed 6 digits');
        return;
      }
      // Validate Indian PIN code format (should start with 1-9 followed by 5 digits)
      if (zipCode.length === 6 && !/^[1-9][0-9]{5}$/.test(zipCode)) {
        toast.error('Invalid Indian PIN code format');
        return;
      }
      setIsAddressAutoFilled(false);
    }
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return str;
    // Ensure first character is a letter and capitalize it
    const firstChar = str.charAt(0);
    if (!/[a-zA-Z]/.test(firstChar)) {
      // If first character is not a letter, remove it
      return str.slice(1);
    }
    return firstChar.toUpperCase() + str.slice(1);
  };

  const handleNameChange = (e, handleChange, setFieldValue, fieldName) => {
    const capitalizedValue = capitalizeFirstLetter(e.target.value);
    setFieldValue(fieldName, capitalizedValue);
  };

  return (
    <div className=" lg:h-[90vh] md:h-[92vh] sm:h-[95vh] overflow-y-scroll w-full p-3">
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="text-primary hover:text-blue-800 pl-2 pt-2"
          onClick={() => navigate("/manageemployee")}
        >
          <MdArrowBack size={24} />
        </button>
        <h2 className="text-xl font-normal text-primary">Add Employee</h2>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={AddUserSchema}
        validateOnChange={true}
        validateOnBlur={true}
        onSubmit={(values, { resetForm }) => {
          setIsSubmitting(true);
          const changedKeys = Object.keys(values).filter(
            (key) => values[key] != initialValues[key]
          ); 

          const changedValues = {};
          changedKeys.forEach((key) => {
            if (key === "joinDate" || key === "endDate") {
              changedValues[key] = moment(values[key]).format(
                "MM-DD-YYYY"
              );
            } else {
              changedValues[key] = values[key];
            }
          });
          handleAddEmployee(
            {
              ...changedValues,
              country: values.country,
              acctType: values.acctType,
              phone: values.phone.replace(/\D/g, ""),
            },
            { resetForm }
          );
        }}
      >
        {({
          values,
          errors,
          touched,
          resetForm,
          handleChange,
          setFieldValue,
          setFieldError,
          setFieldTouched,
        }) => (
          <Form className="grid grid-cols-1 md:grid-cols-3 gap-8 h-[80vh] w-full no-scrollbar rounded p-4">
            {/* Account Information Section */}
            <div className="bg-gray-50 p-5 rounded-lg md:col-span-3">
              <h2 className="text-md font-medium text-slate-400 flex items-center gap-2">
                <FiUser size={18} className="text-cyan-600" /> Account
                Information
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
                <div>
                  <TextInput
                    value={values.userName}
                    name="userName"
                    placeholder="User Name"
                    handleChange={handleChange}
                    legend
                  />
                  {errors.userName && touched.userName && (
                    <div className="text-red-500 text-sm">
                      {errors.userName}
                    </div>
                  )}
                </div>
                <div>
                  <TextInput
                    value={values.password}
                    name="password"
                    placeholder="Password"
                    handleChange={handleChange}
                    type="password"
                    legend
                  />
                  {errors.password && touched.password && (
                    <div className="text-red-500 text-sm">
                      {errors.password}
                    </div>
                  )}
                </div>
                <div>
                  <TextInput
                    value={values.email}
                    name="email"
                    placeholder="Email"
                    handleChange={handleChange}
                    legend
                  />
                  {errors.email && touched.email && (
                    <div className="text-red-500 text-sm">{errors.email}</div>
                  )}
                </div>
              </div>
            </div>

            {/* Personal Information Section */}
            <div className="bg-gray-50 p-5 rounded-lg md:col-span-3">
              <h2 className="text-md font-medium text-slate-400 flex items-center gap-2">
                <FiUsers size={18} className="text-cyan-600" /> Personal
                Information
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
                <div>
                  <TextInput
                    value={values.firstName}
                    name="firstName"
                    placeholder="First Name"
                    handleChange={(e) => {
                      handleNameChange(e, handleChange, setFieldValue, "firstName");
                    }}
                    legend
                  />
                  {errors.firstName && touched.firstName && (
                    <div className="text-red-500 text-sm">
                      {errors.firstName}
                    </div>
                  )}
                </div>
                <div>
                  <TextInput
                    value={values.lastName}
                    name="lastName"
                    placeholder="Last Name"
                    handleChange={(e) => {
                      handleNameChange(e, handleChange, setFieldValue, "lastName");
                    }}
                    legend
                  />
                  {errors.lastName && touched.lastName && (
                    <div className="text-red-500 text-sm">
                      {errors.lastName}
                    </div>
                  )}
                </div>
                <div>
                  <TextInput
                    value={values.phone}
                    name="phone"
                    placeholder="Phone Number"
                    type="tel"
                    handleChange={handleChange}
                    legend
                  />
                  {errors.phone && touched.phone && (
                    <div className="text-red-500 text-sm">{errors.phone}</div>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                <div>
                  <MuiDatePicker
                    label="Start Date"
                    value={values?.joinDate ? moment(values?.joinDate) : null}
                    onChange={(date) => {
                      setFieldValue(
                        "joinDate",
                        moment(date).format("MM-DD-YYYY")
                      );
                    }}
                    className="w-full h-10"
                    maxDate={moment()}
                  />
                  {errors.joinDate && touched.joinDate && (
                    <div className="text-red-500 text-sm">
                      {errors.joinDate}
                    </div>
                  )}
                </div>
                <div>
                  <MuiDatePicker
                    label="End Date"
                    value={values?.endDate ? moment(values?.endDate) : null}
                    onChange={(date) => {
                      setFieldValue(
                        "endDate",
                        moment(date).format("MM-DD-YYYY")
                      );
                    }}
                    className="w-full h-10"
                    minDate={moment()}
                  />
                  {errors.endDate && touched.endDate && (
                    <div className="text-red-500 text-sm">{errors.endDate}</div>
                  )}
                </div>
                <div>
                  <MuiDatePicker
                    label="Date of Birth"
                    value={values?.dateOfBirth ? moment(values?.dateOfBirth) : null}
                    onChange={(date) => {
                      setFieldValue(
                        "dateOfBirth",
                        moment(date).format("MM-DD-YYYY")
                      );
                    }}
                    className="w-full h-10"
                    // minDate={moment()}
                    maxDate={moment().subtract(18,'years')}
                  />
                  {errors.dateOfBirth && touched.dateOfBirth && (
                    <div className="text-red-500 text-sm">{errors.dateOfBirth}</div>
                  )}
                </div>
              </div>
              <div className="md:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
                <div className="flex items-center space-x-4">
                  <label className="text-gray-700 text-sm cursor-default">
                    Gender:
                  </label>
                  <div className="flex items-center space-x-4">
                    <label className="flex items-center space-x-2">
                      <Field
                        type="radio"
                        name="gender"
                        value="M"
                        id="gender-male"
                      />
                      <span className="text-sm">Male</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <Field
                        type="radio"
                        name="gender"
                        value="F"
                        id="gender-female"
                      />
                      <span className="text-sm">Female</span>
                    </label>
                  </div>
                  {errors.gender && touched.gender && (
                    <div className="text-red-500 text-sm">{errors.gender}</div>
                  )}
                </div>
                <div className="flex items-center space-x-4">
                  <label className="text-gray-700 text-sm cursor-default">
                    Status:
                  </label>
                  <div className="flex items-center space-x-4">
                    <label className="flex items-center space-x-2">
                      <Field
                        type="radio"
                        name="stsCd"
                        value="A"
                        checked={values.stsCd === "A"}
                      />
                      <span className="text-sm">Active</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <Field
                        type="radio"
                        name="stsCd"
                        value="D"
                        checked={values.stsCd === "D"}
                      />
                      <span className="text-sm">Deactive</span>
                    </label>
                  </div>
                  {errors.stsCd && touched.stsCd && (
                    <div className="text-red-500 text-sm">{errors.stsCd}</div>
                  )}
                </div>
                <div className="flex items-center space-x-4">
                  <label className="text-gray-700 text-sm cursor-default">
                    Account Type:
                  </label>
                  <div className="flex items-center space-x-4">
                    <label className="flex items-center space-x-2">
                      <Field
                        type="radio"
                        name="acctType"
                        value="USER"
                        checked={values.acctType === "USER"}
                      />
                      <span className="text-sm">User</span>
                    </label>
                    <label className="flex items-center space-x-2">
                      <Field
                        type="radio"
                        name="acctType"
                        value="ADMIN"
                        checked={values.acctType === "ADMIN"}
                      />
                      <span className="text-sm">Admin</span>
                    </label>
                  </div>
                  {errors.acctType && touched.acctType && (
                    <div className="text-red-500 text-sm">
                      {errors.acctType}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Address Information Section */}
            <div className="bg-gray-50 p-5 rounded-lg md:col-span-3">
              <h2 className="text-md font-semibold text-slate-400 flex items-center gap-2">
                <FaMapMarkerAlt size={18} className="text-cyan-600" /> Address
                Information
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
                <div>
                  <TextInput
                    value={values.addressLine1}
                    name="addressLine1"
                    placeholder="Address Line1"
                    handleChange={handleChange}
                    legend
                  />
                  {errors.addressLine1 && touched.addressLine1 && (
                    <div className="text-red-500 text-sm">
                      {errors.addressLine1}
                    </div>
                  )}
                </div>
                <div>
                  <TextInput
                    value={values.addressLine2}
                    name="addressLine2"
                    placeholder="Address Line2"
                    handleChange={handleChange}
                    legend
                  />
                  {errors.addressLine2 && touched.addressLine2 && (
                    <div className="text-red-500 text-sm">
                      {errors.addressLine2}
                    </div>
                  )}
                </div>
                <div>
                  <TextInput
                    value={values.city}
                    name="city"
                    placeholder="City"
                    handleChange={handleChange}
                    legend
                    isDisabled={isAddressAutoFilled}
                  />
                  {errors.city && touched.city && (
                    <div className="text-red-500 text-sm">{errors.city}</div>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                <div>
                  <TextInput
                    value={values.state}
                    name="state"
                    placeholder="State"
                    handleChange={handleChange}
                    legend
                    isDisabled={isAddressAutoFilled}
                  />
                  {errors.state && touched.state && (
                    <div className="text-red-500 text-sm">{errors.state}</div>
                  )}
                </div>
                <div>
                  <CustomDropdown
                    value={countryOptions.find(
                      (user) => user?.value === values?.country
                    )}
                    name="country"
                    handleChange={(selectedOption) =>
                      handleCountryChange(selectedOption, setFieldValue)
                    }
                    placeholder="Select Country"
                    options={countryOptions}
                  />
                  {errors.country && touched.country && (
                    <div className="text-red-500 text-sm">{errors.country}</div>
                  )}
                </div>
                <div>
                  <TextInput
                    value={values.zip}
                    name="zip"
                    placeholder="Zip Code"
                    handleChange={(e) => {
                      handleChange(e);
                      handleZipCodeChange(e, setFieldValue, values);
                    }}
                    legend
                  />
                  {errors.zip && touched.zip && (
                    <div className="text-red-500 text-sm">{errors.zip}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row lg:justify-end lg:h-10 gap-2 w-full md:col-span-3">
              <button
                type="button"
                className="bg-gray-300 text-black rounded-lg hover:bg-gray-400 sm:w-full lg:w-48 lg:mr-2 mr-0 px-4 py-2 h-10"
                onClick={() => navigate("/manageemployee")}
              >
                Cancel
              </button>
              <button
                type="submit"
                className={`bg-primary text-white rounded-lg lg:mr-2 mr-0 sm:w-full lg:w-48 px-4 py-2 ${
                  isSubmitting
                    ? "bg-blue-300 cursor-not-allowed opacity-50"
                    : "bg-primary hover:bg-primaryDark"
                }`}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Hoc(AddEmployeeForm);
